import React, { useEffect, useState } from "react";
import axios from "axios";
import ActivityTicker from "@/components/ActivityTicker";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Drop() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sessionStatus, setSessionStatus] = useState(null);

  useEffect(() => {
    axios.get(`${BASE}/drop/products`).then(r => { setProducts(r.data); setLoading(false); });
  }, []);

  // Poll if we returned from Stripe
  useEffect(() => {
    if (!window.location.pathname.includes("/drop/success")) return;
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) return;
    setSessionStatus({ state: "checking" });
    let attempts = 0;
    const poll = async () => {
      try {
        const r = await axios.get(`${BASE}/drop/status/${sid}`);
        if (r.data.payment_status === "paid") {
          setSessionStatus({ state: "paid", data: r.data });
          return;
        }
        if (r.data.status === "expired") {
          setSessionStatus({ state: "expired" });
          return;
        }
        if (++attempts < 8) setTimeout(poll, 2000);
        else setSessionStatus({ state: "pending" });
      } catch (e) {
        setSessionStatus({ state: "error", error: e.message });
      }
    };
    poll();
  }, []);

  const buy = async (product_id) => {
    try {
      const r = await axios.post(`${BASE}/drop/checkout`, { product_id, origin_url: window.location.origin });
      window.location.href = r.data.url;
    } catch (e) {
      alert(e.response?.data?.detail || "Checkout failed");
    }
  };

  if (sessionStatus) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6" data-testid="drop-status-page">
        <div className="rc-panel relative p-8 max-w-md text-center">
          <div className="rc-label mb-3">// ORDER STATUS</div>
          {sessionStatus.state === "paid" && (
            <>
              <div className="font-display text-2xl rc-glow-text mb-3">PAYMENT CONFIRMED</div>
              <div className="text-sm text-[var(--rc-text-dim)] mb-6">Thank you, sir. RAW-DATA has logged the sale and updated stock. A confirmation has been queued.</div>
            </>
          )}
          {sessionStatus.state === "checking" && (<div className="rc-label rc-blink">VERIFYING TRANSACTION</div>)}
          {sessionStatus.state === "expired" && (<div className="text-[var(--rc-danger)]">Session expired. Please retry.</div>)}
          {sessionStatus.state === "pending" && (<div className="text-[var(--rc-text-dim)]">Still processing. Check your email shortly.</div>)}
          {sessionStatus.state === "error" && (<div className="text-[var(--rc-danger)]">{sessionStatus.error}</div>)}
          <a href="/drop" className="rc-btn inline-block mt-4" data-testid="back-to-drop">BACK TO DROP</a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-4 sm:p-8" data-testid="drop-page">
      <div className="max-w-6xl mx-auto">
        <div className="rc-panel relative px-5 py-4 flex items-center justify-between mb-4">
          <div>
            <div className="rc-label text-[10px]">// LIMITED DROP · LIVE NOW</div>
            <div className="font-display text-2xl rc-glow-text mt-1">RAW-DATA CLOTHING</div>
          </div>
          <div className="text-right">
            <div className="rc-label text-[10px]">PAYMENTS</div>
            <div className="font-display text-xs mt-1">STRIPE SECURED</div>
          </div>
        </div>

        <ActivityTicker />

        {loading ? <div className="rc-label rc-blink text-center mt-12">LOADING DROP</div> : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {products.map(p => (
              <div key={p.id} className="rc-panel relative overflow-hidden" data-testid={`product-${p.sku}`}>
                <div className="aspect-[4/5] bg-black overflow-hidden">
                  <img src={p.image} alt={p.name} className="w-full h-full object-cover opacity-90 hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-4">
                  <div className="flex items-start justify-between gap-3">
                    <div className="min-w-0 flex-1">
                      <div className="font-display text-base tracking-wide truncate">{p.name}</div>
                      <div className="rc-label text-[9px] mt-1">{p.sku}</div>
                    </div>
                    <div className="font-display rc-glow-text text-lg tabular-nums whitespace-nowrap">£{p.price_gbp.toFixed(2)}</div>
                  </div>
                  <div className="text-[11px] text-[var(--rc-text-dim)] mt-2 line-clamp-2">{p.description}</div>
                  <div className="flex items-center justify-between mt-4">
                    <div className="rc-label text-[9px]">
                      {p.stock > 5 ? `${p.stock} IN STOCK` : p.stock > 0 ? <span className="text-[var(--rc-danger)]">ONLY {p.stock} LEFT</span> : <span className="text-[var(--rc-danger)]">SOLD OUT</span>}
                    </div>
                    <button onClick={() => buy(p.id)} disabled={p.stock <= 0} className="rc-btn !text-[10px] !py-1.5 !px-3" data-testid={`buy-${p.sku}`}>BUY NOW</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="rc-label text-center mt-10 opacity-50 text-[9px]">
          RAW-DATA · LIVE-DROP · POWERED BY THE RAW-DATA BACKEND
        </div>
      </div>
    </div>
  );
}
